import { BASE_URL } from "constants/routes";
import { encryptPayload } from "./encrypt";

export const fetchApplicationStatus = async (params) => {
  const req = `${BASE_URL}/status/fetchApplicationStatus`;
  let req_body = {
    body: params,
  };
  const encryptedBodyRes = await encryptPayload("", req_body, true, true);
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(encryptedBodyRes),
  };
  try {
    return await encryptPayload(req, options, false, true, true);
  } catch (err) {
    console.error(err);
  }
}


